import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const registerUserService = async (newUserDTO: any) => {
    try {
        return await axios.post(`${apiUrl}/users/register`, newUserDTO, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            console.log(error.response.data.message);
            throw new Error(error.response.data.message || 'Error al registrar el usuario');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
}

export const loginService = async (username: string, password: string) => {
    try {
        return await axios.post(`${apiUrl}/auth/authenticate`, {
            username,
            password,
        }, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Nombre de usuario o contraseña inválidos');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
};

export const getUserInfoService = async () => {

    try {
        return  await axios.get(`${apiUrl}/users/role`, { withCredentials: true });
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
}

export const logoutService = async () => {

    try {
        return await axios.get(`${apiUrl}/loggingOut`, { withCredentials: true });
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
}

export const polling = async () => {

    try {
        return await axios.get(`${apiUrl}/users/polling`, { withCredentials: true });
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
}